import { FormControl, FormLabel, Input } from '@chakra-ui/react';

export const FormField = ({
  label,
  name,
  value,
  onChange,
  type = 'text',
  isRequired = true,
  placeholder,
  ...props
}) => (
  <FormControl isRequired={isRequired}>
    <FormLabel>{label}</FormLabel>
    <Input name={name} value={value} onChange={onChange} type={type} placeholder={placeholder} {...props} />
  </FormControl>
);
